
export class SocietyModel
{
	id: number = undefined;
	name: string = undefined;
	notes: string = undefined;
	adress1: string = undefined;
	adress2: string = undefined;
	zipcode: string = undefined;
	town: string = undefined;
	phone: string = undefined;

	
	constructor(values: Object) {
	   if(values) this.exchange(values);
	}
	exchange(values: Object = {}) {
			    for (let p in values) {
	    			    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else {
		    				    		this[p] = values[p];
		    	} 
		    }
		    else if (p == '_embedded') {
	    		this.exchange(values[p]);
	    	}
		  }
	}

	toString()
	{
		return "society.model "+this.name;
	}
}